import { Dispatch, SetStateAction } from 'react';

export enum ETimeFormat {
  dhhmmss = 'dhhmmss',
  mmss = 'mmss',
  ss = 'ss',
}

export type TimerBaseProps = {
  onExpired: () => void;
  seconds: number;
  setSeconds: Dispatch<SetStateAction<number>>;
  counterDatetime?: number;
};
